import { useState } from "react";
import { Camera, FileText, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl, fmtErr } from "../lib/api";
import { compressImage } from "../lib/offline";

const dataUrlToBlob = async (u) => (await fetch(u)).blob();

export const Thumb = ({ src, onRemove, testid }) => {
  const isData = src.startsWith("data:");
  const isPdf = !isData && src.toLowerCase().endsWith(".pdf");
  const url = isData ? src : fileUrl(src);
  return (
    <div className="relative h-20 w-20 overflow-hidden rounded border border-slate-700 bg-slate-900" data-testid={testid}>
      {isPdf ? (
        <a href={url} target="_blank" rel="noreferrer" className="flex h-full items-center justify-center text-slate-300"><FileText className="h-8 w-8" /></a>
      ) : (
        <a href={url} target="_blank" rel="noreferrer"><img src={url} alt="evidence" className="h-full w-full object-cover" /></a>
      )}
      {onRemove && (
        <button type="button" onClick={onRemove} className="absolute right-0.5 top-0.5 rounded bg-black/70 p-0.5"><X className="h-3 w-3" /></button>
      )}
    </div>
  );
};

export const PhotoUpload = ({ value = [], onChange, testid = "photo-upload", label = "Add photo", accept = "image/*", single = false }) => {
  const [busy, setBusy] = useState(false);

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    setBusy(true);
    const out = [];
    for (const file of files) {
      const data = await compressImage(file);
      if (!navigator.onLine) {
        out.push(data);
        continue;
      }
      try {
        const fd = new FormData();
        fd.append("file", file.type.startsWith("image/") ? await dataUrlToBlob(data) : file, file.type.startsWith("image/") ? "photo.jpg" : file.name);
        const r = await api.post("/upload", fd);
        out.push(r.data.path);
      } catch (err) {
        toast.error(fmtErr(err));
      }
    }
    setBusy(false);
    onChange(single ? out.slice(-1) : [...value, ...out]);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {value.map((p, i) => (
        <Thumb key={i} src={p} testid={`${testid}-thumb-${i}`} onRemove={() => onChange(value.filter((_, j) => j !== i))} />
      ))}
      <label data-testid={testid} className="flex h-20 w-20 cursor-pointer flex-col items-center justify-center gap-1 rounded border border-dashed border-slate-600 text-[10px] uppercase tracking-wider text-slate-400 hover:border-rose-500 hover:text-rose-300">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Camera className="h-5 w-5" />}
        {label}
        <input type="file" accept={accept} capture={accept === "image/*" ? "environment" : undefined} multiple={!single} className="hidden" onChange={onFiles} data-testid={`${testid}-input`} />
      </label>
    </div>
  );
};
